import {ColDef, ICellRendererParams} from "ag-grid-community";
import {t} from "i18next";
import React, {ReactNode} from "react";
import {PeakEntityResponse} from "../../api/types/peak";
import {dateFormatter} from "../../utils";

export const peakColDef = ({
                               actionsRenderer,
                               actionColDef,
                               user
                           }: {
    actionsRenderer: (params: ICellRendererParams) => ReactNode;
    actionColDef: ColDef;
    user: any
}): ColDef<PeakEntityResponse>[] => [
    {
        field: "legalEntities",
        headerName: t("pricing:peaks.table.headers.legalEntities"),
        headerTooltip: t("pricing:peaks.table.headers.legalEntities"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:legalEntities.'.concat(params.data.legalEntity)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        field: "dealers",
        headerName: t("pricing:peaks.table.headers.dealers"),
        headerTooltip: t("pricing:peaks.table.headers.dealers"),
        editable: false,
        flex: 1,
        filter: "text",
        cellRenderer: (params: ICellRendererParams) => t('translation:dealers.'.concat(params.data.dealer)),
        hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
    },
    {
        headerName: t("pricing:peaks.table.headers.name"),
        headerTooltip: t("pricing:peaks.table.headers.name"),
        field: "name",
        sortable: true,
        flex: 1,
        filter: "text",
    },
    {
        field: "showOnlyActive",
        hide: true,
        filter: "text",
    },
    {
        headerName: t("pricing:peaks.form.labels.commercialSegment"),
        headerTooltip: t("pricing:peaks.form.labels.commercialSegment"),
        field: "commercialSegmentId",
        cellRenderer: (params: ICellRendererParams) =>
            params.data.commercialCategory?.commercialSegment.name,
        flex: 1,
        sortable: false,
        filter: "text",
    },
    {
        headerName: t("pricing:peaks.table.headers.commercialCategory"),
        headerTooltip: t("pricing:peaks.table.headers.commercialCategory"),
        field: "commercialCategoryId",
        cellRenderer: (params: ICellRendererParams) => {
            const category = params.data?.commercialCategory;
            const legalEntity = params.data?.legalEntity;
            
            if (!category) {
                return '';
            }
            
            if (!category.labels || category.labels.length === 0) {
                return category.name || '';
            }
            
            const labelObj = category.labels.find((l: any) => l.country === legalEntity);
            return labelObj?.label || category.name || '';
        },
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        headerName: t("pricing:peaks.table.headers.from"),
        headerTooltip: t("pricing:peaks.table.headers.from"),
        field: "from",
        valueFormatter: (params) =>
            params.data?.from ? dateFormatter(params.data?.from) : "",
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        headerName: t("pricing:peaks.table.headers.to"),
        headerTooltip: t("pricing:peaks.table.headers.to"),
        field: "to",
        valueFormatter: (params) =>
            params.data?.to ? dateFormatter(params.data?.to) : "",
        flex: 1,
        sortable: true,
        filter: "text",
    },
    {
        ...actionColDef,
        cellRenderer: actionsRenderer,
    },
];
